"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const os_1 = __importDefault(require("os"));
const platform_1 = __importDefault(require("platform"));
const axios_1 = __importDefault(require("axios"));
const package_json_1 = require("../package.json");
class ApiClient {
    constructor(authProvider, apiBaseUrl, options) {
        var _a, _b, _c, _d;
        this.authProvider = authProvider;
        this.apiBaseUrl = apiBaseUrl;
        this.options = options;
        this.axiosInstance = axios_1.default.create({
            baseURL: this.apiBaseUrl,
            proxy: (_a = this.options) === null || _a === void 0 ? void 0 : _a.proxy,
            timeout: (_b = this.options) === null || _b === void 0 ? void 0 : _b.timeoutInMs,
            headers: {
                "X-API-Key": this.authProvider.getApiKey(),
                "User-Agent": this.getUserAgent()
            }
        });
        if ((_d = (_c = options === null || options === void 0 ? void 0 : options.customAxiosOptions) === null || _c === void 0 ? void 0 : _c.interceptors) === null || _d === void 0 ? void 0 : _d.response) {
            this.axiosInstance.interceptors.response.use(options.customAxiosOptions.interceptors.response.onFulfilled, options.customAxiosOptions.interceptors.response.onRejected);
        }
    }
    getUserAgent() {
        var _a, _b;
        let userAgent = `fireblocks-sdk-js/${package_json_1.version}`;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.anonymousPlatform)) {
            userAgent += ` (${os_1.default.type()} ${os_1.default.release()}; ${platform_1.default.name} ${platform_1.default.version}; ${os_1.default.arch()})`;
        }
        if ((_b = this.options) === null || _b === void 0 ? void 0 : _b.userAgent) {
            userAgent = `${this.options.userAgent} ${userAgent}`;
        }
        return userAgent;
    }
    issueGetRequestForTransactionPages(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.authProvider.signJwt(path);
            const res = yield this.axiosInstance.get(path, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            return {
                transactions: res.data,
                pageDetails: {
                    prevPage: res.headers["prev-page"] ? res.headers["prev-page"].toString() : "",
                    nextPage: res.headers["next-page"] ? res.headers["next-page"].toString() : "",
                }
            };
        });
    }
    issueGetRequest(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.authProvider.signJwt(path);
            const res = yield this.axiosInstance.get(path, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            return res.data;
        });
    }
    issuePostRequest(path, body, requestOptions) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.authProvider.signJwt(path, body);
            const headers = { "Authorization": `Bearer ${token}` };
            const idempotencyKey = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.idempotencyKey;
            if (idempotencyKey) {
                headers["Idempotency-Key"] = idempotencyKey;
            }
            const ncwWalletId = (_a = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.ncw) === null || _a === void 0 ? void 0 : _a.walletId;
            if (ncwWalletId) {
                headers["X-End-User-Wallet-Id"] = ncwWalletId;
            }
            const response = yield this.axiosInstance.post(path, body, { headers });
            return response.data;
        });
    }
    issuePutRequest(path, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.authProvider.signJwt(path, body);
            const res = (yield this.axiosInstance.put(path, body, {
                headers: { "Authorization": `Bearer ${token}` }
            }));
            return res.data;
        });
    }
    issuePatchRequest(path, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.authProvider.signJwt(path, body);
            const res = (yield this.axiosInstance.patch(path, body, {
                headers: { "Authorization": `Bearer ${token}` }
            }));
            return res.data;
        });
    }
    issueDeleteRequest(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.authProvider.signJwt(path);
            const res = (yield this.axiosInstance.delete(path, {
                headers: { "Authorization": `Bearer ${token}` }
            }));
            return res.data;
        });
    }
}
exports.ApiClient = ApiClient;
//# sourceMappingURL=api-client.js.map